module.exports = __webpack_public_path__ + "img/2.5b3d3fb3.jpg";